import { render, staticRenderFns } from "./BlockOrderedList.vue?vue&type=template&id=6f84a867&"
import script from "./BlockOrderedList.vue?vue&type=script&lang=js&"
export * from "./BlockOrderedList.vue?vue&type=script&lang=js&"
import style0 from "./BlockOrderedList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports